export default Backbone.GoogleMaps.Location.extend({
  // A model for the markers that appear on the map

  getSearchResult() {
    if (!this.collection) {
      return undefined;
    }

    let allResults = [];
    const results = this.collection.searchResults.get('results');
    if (results) {
      allResults = results;
    }

    const alt_results = this.collection.searchResults.get('alternate_results');
    if (alt_results) {
      allResults = allResults.concat(alt_results);
    }

    if (allResults.length == 0) {
      return undefined;
    }

    return allResults[this.get('rank') - 1];
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/search/search_result_marker.js